import { graphql, useStaticQuery } from 'gatsby';

export default function MachineLearningMenuLinks() {
  const MachineLearningMenu = useStaticQuery(graphql`
    query MyQuery {
      allMenuLinkContentMachineLearning {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return MachineLearningMenu;
}
